var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContrast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25.25H1.75C.925.25.25.925.25 1.75v10.5c0 .825.675 1.5 1.5 1.5h10.5c.825 0 1.5-.675 1.5-1.5V1.75c0-.825-.675-1.5-1.5-1.5zm-9.188 3h2.626c.307 0 .562.255.562.563a.567.567 0 01-.563.562H3.063a.567.567 0 01-.562-.563c0-.307.255-.562.563-.562zm8.438 9H1.75l10.5-10.5v9.75c0 .412-.338.75-.75.75zM8.875 10v.938c0 .307.255.562.563.562a.567.567 0 00.562-.563V10h.938a.567.567 0 00.562-.563.567.567 0 00-.563-.562H10v-.938a.567.567 0 00-.563-.562.567.567 0 00-.562.563v.937h-.938a.567.567 0 00-.562.563c0 .307.255.562.563.562h.937z",
    fill: "#499D71"
  })));
}
export default SvgContrast;